import { render, staticRenderFns } from "./MovementObject.vue?vue&type=template&id=4e345040&"
import script from "./MovementObject.vue?vue&type=script&lang=js&"
export * from "./MovementObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports